import React, { Component, useCallback, useState } from "react";
import style from "./Toolbar.module.scss";
import {
  Col,
  Row,
  Button,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import Responsive from "react-responsive";
import SearchBox from "./SearchBox";
import Advanced from "./Advanced";
import { debounce } from "../../../utils/Helper";
import { Process } from "../types";

const Toolbar = ({ onChange: rootOnChange, filter: rootFilter, counters }) => {
  const [openAdvanced, setOpenAdvanced] = useState(false);
  const [filters, setFilters] = useState(rootFilter);

  const debounceCallback = useCallback(
    debounce((nextValues) => rootOnChange(nextValues), 500),
    []
  );

  const onChange = (fields) => {
    const nextValues = {
      ...filters,
      ...fields,
      advanced: openAdvanced,
    };
    debounceCallback(nextValues);
    setFilters(nextValues);
  };

  return (
    <div className={style.toolbar}>
      <Row>
        <Col lg={2}>
          <Counter {...counters} />
        </Col>
        <Col lg={6}>
          <div>
            <SearchBox onChange={onChange} toggle={() => setOpenAdvanced(true)} {...filters} />
            {/* <Advanced
              toggle={() => setOpenAdvanced(false)}
              onChange={onChange}
              open={openAdvanced}
              {...filters}
            /> */}
          </div>
        </Col>

        <Col lg={2} className={style.filterDropdown}>
          <DropDownFilterProcess value={filters.process} onChange={onChange} />
        </Col>

        <Col lg={2} className={style.export}>
          <Button color="primary" onClick={() => null}>
            <i className="fa fa-download"></i>
          </Button>
        </Col>
      </Row>
    </div>
  );
};

const Counter = ({ total }) => (
  <div className="d-none d-lg-block">
    <h6 className={"h6 page-title " + style.totals}>Events: {total}</h6>
  </div>
);

const DropDownFilterProcess = ({ value, onChange }) => (
  <UncontrolledDropdown style={{ minWidth: "160px" }}>
    <DropdownToggle caret color="secondary" className={style.dropdown}>
      {value == "" ? "All Processes" : value}
    </DropdownToggle>
    <DropdownMenu>
      <DropdownItem key={`process-all`} onClick={() => onChange({ process: "" })}>
        {"All Processes"}
      </DropdownItem>
      {Object.values(Process).map((process) => (
        <DropdownItem key={`process-${process}`} onClick={() => onChange({ process: process })}>
          {process}
        </DropdownItem>
      ))}
    </DropdownMenu>
  </UncontrolledDropdown>
);

export default Toolbar;
